package com.neurobs.ccabserver.administrator.view

import com.neurobs.ccab.{BatteryLevel, PowerStatusData}
import com.neurobs.js.view.{Container, Gui}
import com.neurobs.js.dom.DOMViewElement._
import scalatags.JsDom.all._
import org.scalajs.dom.html._
import org.scalajs.dom.raw._

class PowerStatusView(gui: Gui) {
	import PowerStatusView._

	private def createImage(localPath: String): Image = img(style := "display:none;height:1.3em;vertical-align:middle", src := gui.resourcePaths.getImagePath(localPath)).render

	private val outletImage = createImage(localPath = "plug_white.png")
	private val batteryImage = createImage(localPath = "battery_red.png")
	//private val lowBatteryImage = createImage(localPath = "battery_red.png")
	private val batteryPercent = span(style := "display:none;color:red;").render
	private val powerStatus = table(style := "display:none;", tr(td(style := "vertical-align:middle", outletImage, batteryImage), td(style := "vertical-align:middle", batteryPercent))).render

	def set(data: PowerStatusData): Unit = {
		hide(outletImage)
		hide(batteryImage)
		hide(batteryPercent)
		hide(powerStatus)
		val lifetime: String = data.battery_life_seconds match {
			case None => ""
			case Some(s) =>
				val m = s / 60
				f"(${m / 60}:${m % 60}%02d)"
		}
		if (data.ac_power.getOrElse(false)) {
			show(outletImage)
			show(powerStatus)
		}
		else if (data.battery_present.getOrElse(false)) {
			data.battery_percent match {
				case Some(p) =>
					show(powerStatus)
					show(batteryImage)
					batteryPercent.innerHTML = s"$p% $lifetime"
					show(batteryPercent)
				case None =>
					data.level match {
						case Some(l) =>
							show(powerStatus)
							show(batteryImage)
							batteryPercent.innerHTML = s"${l.toString} $lifetime"
							show(batteryPercent)
						case None =>
					}
			}
		}
	}

	def container = powerStatus
}

object PowerStatusView {
	def show(e: HTMLElement): Unit = e.style.display = "inline-block"
	def hide(e: HTMLElement): Unit = e.style.display = "none"
}
